/*************************************************/
/* COMPARISON                                    */
/*************************************************/
export function comparison() {
    const cardSelector = ".comparison-card";
    const cardCollapsedClass = "comparison-card--collapsed";
    const toggleOnSelector = ".comparison-card__toggle--on";
    const toggleOffSelector = ".comparison-card__toggle--off"
    
    const init = () => {
        var onButtons = document.querySelectorAll(toggleOnSelector);
        if(onButtons) {
            onButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const card = button.closest(cardSelector);
                    card.classList.remove(cardCollapsedClass);

                });
            });
        }

        var offButtons = document.querySelectorAll(toggleOffSelector);
        if(offButtons) {
            offButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const card = button.closest(cardSelector);
                    card.classList.add(cardCollapsedClass);
                });
            });
        }
    };

    init();

}

